/**
 * 랜딩 설정. 원본 landing/index.html 의 `window.SITE_CONFIG` 에 대응합니다.
 *
 * ★ 신청 폼 엔드포인트가 아직 비어 있습니다.
 * 원본 레포의 `api/apply.js`(카카오워크 웹훅 중계)는 Vercel 서버리스 함수라
 * 이 프로젝트(`output:"export"` 정적 빌드)에서는 그대로 못 씁니다.
 * 대신 카카오워크로 중계하는 Lambda 를 배포하고 그 Function URL 을 아래에 넣습니다.
 * * (Lambda 코드는 웹훅 URL 노출을 피하려고 이 레포 바깥에 둔다. `../dq-landing-apply/`)
 * 비워 둔 동안에는 폼이 전송 없이 완료 화면만 띄우고 입력값을 콘솔에 남깁니다.
 */

import { trackEvent } from "@/utils/analytics";

/** dev 스택(`codehana-landing-apply-dev`)의 Function URL */
const DEV_FORM_ENDPOINT = "https://qg2mslxhhotouyhx2twmajjvym0lymvp.lambda-url.ap-northeast-2.on.aws/";
/** prod 스택(`codehana-landing-apply-prod`)의 Function URL */
const PROD_FORM_ENDPOINT = "https://6tqd3ozkbimmwutg6n6huo4any0rglpz.lambda-url.ap-northeast-2.on.aws/";

/**
 * 정적 빌드라 빌드 시점에 환경을 못 가르므로, 런타임 호스트명으로 고릅니다
 * (`src/utils/getApiBaseUrl.ts` 와 같은 방식).
 *
 * * ★ Lambda 는 환경별로 스택이 따로다. CORS 오리진이 Function URL 설정에 박혀 있어
 * 한쪽 URL 을 다른 환경에서 부르면 브라우저가 막습니다.
 */
export function getLandingFormEndpoint(): string {
  if (typeof window === "undefined") return "";

  const hostname = window.location.hostname.toLowerCase();
  // 운영 FE 호스트만 prod Lambda. dev·localhost·그 외는 전부 dev Lambda (getApiBaseUrl 과 같은 방향).
  const isProd = hostname === "dq.ai.kr" || hostname === "haebom.ai.kr";
  return isProd ? PROD_FORM_ENDPOINT : DEV_FORM_ENDPOINT;
}

/**
 * 랜딩 이벤트 전송. GA4 계측(`src/utils/analytics.ts`)으로 위임한다 — 검색 유입 키워드 파라미터가 자동으로 붙는다.
 */
export function trackLandingEvent(name: string, params: Record<string, unknown> = {}) {
  trackEvent(name, params);
}
